/**
 * sm2Util.ts
 * 实现 SM2 加解密，自动生成并保存公私钥
 */
import smCrypto from 'sm-crypto'
const { sm2 } = smCrypto

class SM2Util {
  private privateKey: string = ''
  private publicKey: string = ''

  constructor() {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      this._initKeys()
    } else {
      console.warn(
        '[sm2Util] localStorage not available; SM2 key not initialized.'
      )
    }
  }

  /** 初始化密钥对，优先从 localStorage 读取，否则生成新的并保存 */
  private _initKeys() {
    const priv = localStorage.getItem('__cacheUtil_sm2_priv')
    const pub = localStorage.getItem('__cacheUtil_sm2_pub')
    if (priv && pub) {
      this.privateKey = priv
      this.publicKey = pub
    } else {
      const keypair = sm2.generateKeyPairHex()
      this.privateKey = keypair.privateKey
      this.publicKey = keypair.publicKey
      localStorage.setItem('__cacheUtil_sm2_priv', this.privateKey)
      localStorage.setItem('__cacheUtil_sm2_pub', this.publicKey)
    }
  }

  /** 加密字符串，输出 hex 编码 */
  encrypt(data: string): string {
    try {
      return sm2.doEncrypt(data, this.publicKey, 1)
    } catch (e) {
      console.error('[sm2Util] encryption failed:', e)
      return ''
    }
  }

  /** 解密 hex 编码字符串 */
  decrypt(encrypted: string): string {
    try {
      return sm2.doDecrypt(encrypted, this.privateKey, 1)
    } catch (e) {
      console.error('[sm2Util] decryption failed:', e)
      return ''
    }
  }

  /** 清除本地密钥（调试或切换用户时可用） */
  resetKeys() {
    localStorage.removeItem('__cacheUtil_sm2_priv')
    localStorage.removeItem('__cacheUtil_sm2_pub')
    this._initKeys()
  }

  /** 获取公钥（如果需要公开传输用） */
  getPublicKey(): string {
    return this.publicKey
  }
}

export default new SM2Util()
